export enum ReInitPicCompActions{
    RE_INIT = 'RE_INIT',
    INIT = 'INIT'
}